import sync, { cancelSync } from "framesync";
import { Action, action, calc } from "popmotion";
import { MultiPhysicsProps, MultiPhysicsInterface } from "./multiPhysicsTypes";

const speedPerFrame = calc.speedPerFrame;

const physics = (
  props: MultiPhysicsProps = {}
): Action<MultiPhysicsInterface> =>
  action(
    ({ complete, update }): MultiPhysicsInterface => {
      let {
        acceleration = [0, 0],
        friction = 0,
        velocity = [0, 0],
        springs = [],
        sources = [],
      } = props;
      const { from = [0, 0] } = props;
      let current = from;

      const process = sync.update(({ delta }) => {
        // Integration doesn't work well with very low numbers
        const elapsed = Math.max(delta, 16);

        for (let i = 0; i < 2; i++) {
          if (acceleration[i]) {
            velocity[i] += speedPerFrame(acceleration[i], elapsed);
          }

          if (friction) {
            velocity[i] *= (1 - friction) ** (elapsed / 100);
          }

          for (let spring of springs) {
            if (spring.strength !== undefined && spring.origin !== undefined) {
              const distanceToTarget = spring.origin[i] - current[i];
              velocity[i] +=
                distanceToTarget * speedPerFrame(spring.strength, elapsed);
            }
          }
        }

        for (let source of sources) {
          if (
            typeof source.strength !== "undefined" &&
            typeof source.origin !== "undefined"
          ) {
            const distanceToTargetX = source.origin[0] - current[0];
            const distanceToTargetY = source.origin[1] - current[1];

            let absoluteDistance = Math.sqrt(
              distanceToTargetX ** 2 + distanceToTargetY ** 2
            );
            if (absoluteDistance < 10) absoluteDistance = 10;
            let intFactor = 1 / absoluteDistance ** 2;
            if (intFactor > 1000000) {
              intFactor = 1000000;
            }
            const v = intFactor * speedPerFrame(source.strength, elapsed);

            velocity[0] += (v * distanceToTargetX) / absoluteDistance;
            velocity[1] += (v * distanceToTargetY) / absoluteDistance;

            if (absoluteDistance < 20 && absoluteDistance > -20) {
              console.log(
                "distance",
                absoluteDistance,
                "dx",
                distanceToTargetX,
                "dy",
                distanceToTargetY,
                "init",
                intFactor,
                "v",
                v,
                "total",
                velocity
              );
            }
          }
        }

        current = current.map(
          (c, i) => c + speedPerFrame(velocity[i], elapsed)
        ) as [number, number];

        update(current);
      }, true);

      return {
        set(v) {
          current = v;
          return this;
        },
        setAcceleration(v) {
          acceleration = v;
          return this;
        },
        setFriction(v) {
          friction = v;
          return this;
        },
        setSprings(v) {
          springs = v;
          return this;
        },
        setSources(v) {
          sources = v;
          return this;
        },
        setVelocity(v) {
          velocity = v;
          return this;
        },
        stop: () => cancelSync.update(process),
      };
    }
  );

export default physics;
